export const mapAgentReq = (agentData) => {
  const {
    AIR,
    SEA,
    LAND,
    coLoad,
    borrowAws,
    uplift,
    payLoadShippingList,
    deletedShipmentIds,
    isShippingAgentValue,
  } = agentData;

  console.log(agentData, "agentData");
  
  // ⭐ AIR
   const air = cleanObject({
    overseasAgent: AIR?.overseasAgent,
    localAgent: AIR?.localAgent,
    profitSharing: AIR?.profitSharing,
    commission: AIR?.commission,
    incentive: AIR?.incentive,
  });

  // ⭐ SEA
  const sea = cleanObject({
    overseasAgent: SEA?.seaOverSeasAgent,
    localAgent: SEA?.seaLocalAgent,
    profitSharing: SEA?.seaProfitSharing,
    commission: SEA?.seaCommission,
    incentive: SEA?.seaIncentive,
  });

  // ⭐ LAND
  const land = cleanObject({
    overseasAgent: LAND?.landOverseasAgent,
    localAgent: LAND?.landLocalAgent,
    profitSharing: LAND?.profitSharing,
    commission: LAND?.landCommission,
    incentive: LAND?.landIncentive,
  });

  // ⭐ CoLoad
  const coLoadAgent = coLoad?.landOverseasAgent;

  // ⭐ Borrow AWS
  const borrowClean = cleanObject({
    borrowGsaAir: borrowAws?.overseasAgent,
    borrowGsaPercentage: borrowAws?.commission,
    iataCode: borrowAws?.IATACode,
    accountNo: borrowAws?.AccountNo,
  });

  // ⭐ Currency uplift
  const currencyUpLift = cleanObject({
    airValue: uplift?.airTextField,
    airUnit: uplift?.airDropDown,
    seaValue: uplift?.seaTextField,
    seaUnit: uplift?.seaDropDown,
  });

    const agent = {};

  if (air) agent.air = air;
  if (sea) agent.sea = sea;
  if (land) agent.land = land;
  if (coLoadAgent !== undefined) agent.coLoadAgent = coLoadAgent;
  if (borrowClean) Object.assign(agent, borrowClean);
  if (currencyUpLift) agent.currencyUpLift = currencyUpLift;


  // ⭐ SHIPMENTS
  const shipments = (payLoadShippingList || []).map((s) => ({
    shippingLine: s.id || null,
    isShipment: isShippingAgentValue ?? false,
  }));

  // ⭐ FINAL PAYLOAD WRAPPED IN REQUEST
  return {
    agent,
    shipments,
    deletedShipmentIds,
  };
};

const cleanObject = (obj) => {
  const result = {};

  Object.entries(obj).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      result[key] = value;
    }
  });

  return Object.keys(result).length > 0 ? result : null;
};


// const deepClean = (obj) => {
//   if (Array.isArray(obj)) {
//     const cleanedArr = obj
//       .map((item) => deepClean(item))
//       .filter((item) => item && Object.keys(item).length > 0);
//     return cleanedArr.length ? cleanedArr : undefined;
//   }

//   if (typeof obj === "object" && obj !== null) {
//     const cleanedObj = {};
//     Object.entries(obj).forEach(([key, value]) => {
//       const cleanedValue = deepClean(value);
//       if (
//         cleanedValue !== undefined &&
//         cleanedValue !== null &&
//         cleanedValue !== "" &&
//         !(
//           typeof cleanedValue === "object" &&
//           Object.keys(cleanedValue).length === 0
//         )
//       ) {
//         cleanedObj[key] = cleanedValue;
//       }
//     });
//     return Object.keys(cleanedObj).length > 0 ? cleanedObj : {};
//   }

//   return obj;
// };

export const mapAgentResp = (apiData) => {
  if (!apiData) return {};

  const agent = apiData.agent || {};
  const shipments = apiData.shipments || [];

  // ⭐ AIR → AIR
  const AIR = agent.air
    ? {
        overseasAgent: agent.air.overseasAgent,
        localAgent: agent.air.localAgent,
        profitSharing: agent.air.profitSharing,
        commission: agent.air.commission,
        incentive: agent.air.incentive,
      }
    : {};

  // ⭐ SEA → SEA
  const SEA = agent.sea
    ? {
        seaOverSeasAgent: agent.sea.overseasAgent,
        seaLocalAgent: agent.sea.localAgent,
        seaProfitSharing: agent.sea.profitSharing,
        seaCommission: agent.sea.commission,
        seaIncentive: agent.sea.incentive,
      }
    : {};

  // ⭐ LAND → LAND
  const LAND = agent.land
    ? {
        landOverseasAgent: agent.land.overseasAgent,
        landLocalAgent: agent.land.localAgent,
        profitSharing: agent.land.profitSharing,
        landCommission: agent.land.commission,
        landIncentive: agent.land.incentive,
      }
    : {};

  // ⭐ Co-Load Agent
  const coLoad = {
    landOverseasAgent: agent.coLoadAgent,
  };

  // ⭐ Borrow AWS
  const borrowAws = {
    overseasAgent: agent.borrowGsaAir,
    commission: agent.borrowGsaPercentage,
    IATACode: agent.iataCode,
    AccountNo: agent.accountNo,
  };

  // ⭐ Currency Uplift (Not in API response → default blank)
  const uplift = {
    airTextField: "",
    airDropDown: "%",
    seaTextField: "",
    seaDropDown: "%",
  };

  // ⭐ Shipping Lines → shippingList
  const shippingList = shipments.map((s) => ({
    id: s.customerAgentShipmentId,
    name: s.shippingLine?.name,
    customerAgentShipmentId: s.customerAgentShipmentId,
    isShippingAgent: s.isShipment ?? false,
  }));

  return {
    AIR,
    SEA,
    LAND,
    coLoad,
    borrowAws,
    uplift,
    shippingList,
  };
};
